<template>
    <v-dialog
      v-model="dialog"
      persistent max-width="50vw"
      :style="{'z-index': zIndexUpdtUserPass}"
    >
      <v-card ref="inputs"
        @keydown.enter="updatePassword"
      >
        <v-card-title>Your password has expired</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-10">
          <p class="mb-6">Your password has expired. Choose a new password to continue.</p>
          <v-text-field
            id="passwordUpdate"
            solo
            v-model="password"
            label="New password"
            :prepend-inner-icon="icons.mdiAccountKey"
            :type="showPass ? 'text' : 'password'"
            @click:append="showPass = !showPass"
            :append-icon="showPass ? icons.mdiEye : icons.mdiEyeOff"
            :error-messages="passErrorMsgs"
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
          >
          </v-text-field>
          <!-- <v-text-field
            id="confirmPasswordUpdate"
            solo
            v-model="confirmPassword"
            label="Password"
            :prepend-inner-icon="icons.mdiAccountKey"
            :type="showConfPass ? 'text' : 'password'"
            @click:append="showConfPass = !showConfPass"
            :append-icon="showConfPass ? icons.mdiEye : icons.mdiEyeOff"
            :error-messages="confPassErrorMsgs"
            @input="$v.password.$touch()"
            @blur="$v.password.$touch()"
          >
          </v-text-field> -->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn
            id="updatePasswordButton"
            color="secondary"
            class="ma-2 white--text"
            @click="updatePassword"
          >
            Save new password
            <v-icon right> {{icons.mdiLogin}} </v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>

import {
  mdiAccount,
  mdiAccountKey,
  mdiEye,
  mdiEyeOff,
  mdiLogin,
} from '@mdi/js';
import { mapState } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import { TMC_CONSTANTS } from '../../util/shared/constants';

export default {
  mixins: [validationMixin],
  validations() {
    return {
      password: {
        required,
        minLength: minLength(this.minPasswordLength || 0),
      },
    };
  },
  computed: {
    ...mapState({
      minPasswordLength: (state) => (state.SystemConfig.globalSettingItem || {}).minPasswordLength || 0,
    }),
    passErrorMsgs() {
      const v = this.$v;
      return (!v.password.$dirty) ? [] : [
        ...(!v.password.required) ? ['Required'] : [],
        ...(!v.password.minLength) ? [`Must be at least ${this.minPasswordLength} characters`] : [],
      ];
    },
    confPassErrorMsgs() {
      const v = this.$v;
      let errors = [];
      if (v.confirmPassword.$dirty) {
        if (v.confirmPassword.required) {
          if (!v.confirmPassword.sameAsPassword) {
            errors = ['Password mismatched'];
          }
        } else {
          errors = ['Required'];
        }
      }
      return errors;
    },
    dialog() {
      return this.$store.state.auth.token.resetPasswordDialog;
    },
  },

  name: 'LoginUserPass',
  data: () => ({
    icons: {
      mdiAccount,
      mdiAccountKey,
      mdiEye,
      mdiEyeOff,
      mdiLogin,
    },
    showPass: false,
    showConfPass: false,
    password: '',
    confirmPassword: '',
    zIndexUpdtUserPass: TMC_CONSTANTS.COMPONENT_Z_INDEX.UPDATE_USER_PASSWORD_DIALOG,
  }),
  methods: {
    updatePassword() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const updatedData = {
          changingPassUser: localStorage.getItem('auth.user'),
          newPassword: this.password,
        };
        this.$store.dispatch('UserAdministration/resetUsersPassword', updatedData).then((resp) => {
          if (resp.status) {
            this.$store.commit('auth/token/setResetPasswordDialog', false);
            this.$store.dispatch('auth/token/resolveAuth', resp.tokenContext);
          } else {
            this.$store.dispatch('flashError', 'Unable to Confirm the password.');
          }
        }).catch((e) => {
          console.warn(e);
        });
      }
    },
  },
};
</script>
